export default __webpack_public_path__ + "static/media/488.ea72a09a.png";